import type { ReceiptTemplate } from '../schema';

export const attTemplate: ReceiptTemplate = {
  id: 'att',
  name: 'AT&T Receipt',
  brand: 'AT&T',
  description: 'AT&T mobile/store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'att-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/att.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: ['STORE #4892', '1200 DARK AVENUE', 'MONSTERVILLE, CA 94608'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'att-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans #:', value: '847291034' },
          { id: 'assoc', label: 'Associate:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'att-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'IPHONE 15 PRO 256GB', quantity: '1', price: '999.00', sku: '' },
          { id: '2', name: 'ACTIVATION FEE', quantity: '1', price: '35.00', sku: '' },
          { id: '3', name: 'SILICONE CASE', quantity: '1', price: '49.00', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'att-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '1083.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '89.35', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1172.35', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'att-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'att-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'THANK YOU FOR CHOOSING AT&T', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

